import { omit } from "lodash";
import moment from "moment-timezone";
import { useCallback, useState } from "react";

export const useUpdateTimeSheet = (originalData) => {
	const [data, setData] = useState({});

	const update = useCallback(
		(id, d) => {
			setData((prev) => {
				const existing = prev[id];
				let data;
				if (typeof d === "function") {
					data = d(existing);
				} else {
					data = d;
				}
				const updated = {
					isTouched: true,
					...(existing || {}),
					...data,
				};

				if (
					existing?.payCode?.hourType === "amount" &&
					"payCode" in data &&
					data.payCode?.hourType !== "amount"
				) {
					delete updated.rate;
				}

				if (["amount", "unit"].includes(data?.payCode?.hourType)) {
					const date = moment().startOf("day").toISOString();
					updated.startDate = date;
					updated.endDate = date;
				}

				const original = originalData?.find((item) => item.id === id);
				if (original) {
					const reset = Object.keys(omit(updated, ["isTouched"])).every((key) => {
						// TODO: manage comparison cases for object types (pay code, org levels, job, location, etc.)
						return original[key] === updated[key];
					});
					if (reset) {
						return omit(prev, [id]);
					}
				}
				return { ...prev, [id]: updated };
			});
		},
		[setData, originalData]
	);

	const resetOne = useCallback((id) => {
		setData((prev) => {
			return {
				...prev,
				[id]: undefined,
			};
		});
	}, [setData]);

	const reset = useCallback(() => {
		setData({});
	}, [setData]);

	return { data, update, reset, resetOne };
}
